export enum DataKeys {
  total_transactions = 'total_transactions',
  total_gas_spent = 'total_gas_spent',
  total_degree = 'total_degree',
  total_reputation_score = 'total_reputation_score',
}